import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import ResponseMessage from "../common/ResponseMessage";
import LoadingScreen from "../common/LoadingScreen";
import ConstanteViewBase from "../constante/ConstanteViewBase";
import { useConstanteData } from "../../hooks/useConstanteData";

const ConstanteView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { constante, loading, error } = useConstanteData("admin", id);

  useEffect(() => {
    if (!id) {
      console.error("No constante ID provided");
    }
  }, [id]);

  if (loading) return <LoadingScreen message="Chargement des détails de la constante..." role="admin" />;
  if (error || !constante) return <ResponseMessage message={error || "Constante non trouvée"} role="admin" />;

  return <ConstanteViewBase role="admin" constante={constante} />;
};

export default ConstanteView;